interface CustomDatePickerProps {
  selectedDate: string;
  setSelectedDate: (date: string) => void;
  type?: string;
  label?: string;
}

const CustomDatePicker = ({
  selectedDate,
  setSelectedDate,
  type,
  label,
}: CustomDatePickerProps) => {
  return (
    <div>
      {label && (
        <label className="block text-[#969EAE] text-xs mb-1">{label}</label>
      )}
      <div className="relative  flex items-center">
        <svg
          width="18"
          height="19"
          className="absolute left-3 cursor-pointer"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.1057 0.5C5.27279 0.5 5.43303 0.566375 5.55118 0.684523C5.66933 0.802671 5.7357 0.962914 5.7357 1.13V2.3081H12.501V1.1381C12.501 0.971014 12.5674 0.810771 12.6855 0.692623C12.8037 0.574475 12.9639 0.5081 13.131 0.5081C13.2981 0.5081 13.4583 0.574475 13.5765 0.692623C13.6946 0.810771 13.761 0.971014 13.761 1.1381V2.3081H16.2C16.6772 2.3081 17.1349 2.49762 17.4725 2.83499C17.81 3.17236 17.9998 3.62997 18 4.1072V16.7009C17.9998 17.1781 17.81 17.6357 17.4725 17.9731C17.1349 18.3105 16.6772 18.5 16.2 18.5H1.8C1.32277 18.5 0.865065 18.3105 0.527526 17.9731C0.189986 17.6357 0.000238617 17.1781 0 16.7009L0 4.1072C0.000238617 3.62997 0.189986 3.17236 0.527526 2.83499C0.865065 2.49762 1.32277 2.3081 1.8 2.3081H4.4757V1.1291C4.47594 0.96217 4.54242 0.802158 4.66054 0.684204C4.77866 0.566251 4.93877 0.5 5.1057 0.5ZM1.26 7.4678V16.7009C1.26 16.7718 1.27397 16.842 1.30111 16.9075C1.32824 16.9731 1.36802 17.0326 1.41816 17.0827C1.46831 17.1329 1.52784 17.1727 1.59335 17.1998C1.65887 17.2269 1.72909 17.2409 1.8 17.2409H16.2C16.2709 17.2409 16.3411 17.2269 16.4066 17.1998C16.4722 17.1727 16.5317 17.1329 16.5818 17.0827C16.632 17.0326 16.6718 16.9731 16.6989 16.9075C16.726 16.842 16.74 16.7718 16.74 16.7009V7.4804L1.26 7.4678ZM6.0003 13.6571V15.1565H4.5V13.6571H6.0003ZM9.7497 13.6571V15.1565H8.2503V13.6571H9.7497ZM13.5 13.6571V15.1565H11.9997V13.6571H13.5ZM6.0003 10.0778V11.5772H4.5V10.0778H6.0003ZM9.7497 10.0778V11.5772H8.2503V10.0778H9.7497ZM13.5 10.0778V11.5772H11.9997V10.0778H13.5ZM4.4757 3.5672H1.8C1.72909 3.5672 1.65887 3.58117 1.59335 3.6083C1.52784 3.63544 1.46831 3.67522 1.41816 3.72536C1.36802 3.77551 1.32824 3.83504 1.30111 3.90055C1.27397 3.96607 1.26 4.03629 1.26 4.1072V6.2087L16.74 6.2213V4.1072C16.74 4.03629 16.726 3.96607 16.6989 3.90055C16.6718 3.83504 16.632 3.77551 16.5818 3.72536C16.5317 3.67522 16.4722 3.63544 16.4066 3.6083C16.3411 3.58117 16.2709 3.5672 16.2 3.5672H13.761V4.4033C13.761 4.57039 13.6946 4.73063 13.5765 4.84878C13.4583 4.96693 13.2981 5.0333 13.131 5.0333C12.9639 5.0333 12.8037 4.96693 12.6855 4.84878C12.5674 4.73063 12.501 4.57039 12.501 4.4033V3.5672H5.7357V4.3952C5.7357 4.56229 5.66933 4.72253 5.55118 4.84068C5.43303 4.95883 5.27279 5.0252 5.1057 5.0252C4.93861 5.0252 4.77837 4.95883 4.66022 4.84068C4.54207 4.72253 4.4757 4.56229 4.4757 4.3952V3.5672Z"
            fill="#7C8DB5"
          />
        </svg>

        <input
          type={type || "datetime-local"}
          id="meeting-time"
          name="meeting-time"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          className="w-full rounded-lg border h-12 border-[#657A9345]  bg-transparent ps-10 text-[#969EAE] text-sm py-3 "
        />
        <svg
          style={{ zIndex: -1 }}
          className="absolute right-3 -z-1 mt-1 cursor-pointer"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.497 8.48903L12 15.797L4.50299 8.48903C4.36905 8.35819 4.18923 8.28495 4.00199 8.28495C3.81475 8.28495 3.63494 8.35819 3.50099 8.48903C3.43614 8.55257 3.38461 8.62842 3.34944 8.71213C3.31426 8.79584 3.29614 8.88573 3.29614 8.97653C3.29614 9.06733 3.31426 9.15721 3.34944 9.24092C3.38461 9.32463 3.43614 9.40048 3.50099 9.46403L11.4765 17.24C11.6166 17.3765 11.8044 17.453 12 17.453C12.1956 17.453 12.3834 17.3765 12.5235 17.24L20.499 9.46553C20.5643 9.40193 20.6162 9.3259 20.6517 9.24191C20.6871 9.15792 20.7054 9.06769 20.7054 8.97653C20.7054 8.88537 20.6871 8.79513 20.6517 8.71114C20.6162 8.62715 20.5643 8.55112 20.499 8.48753C20.365 8.35669 20.1852 8.28345 19.998 8.28345C19.8108 8.28345 19.6309 8.35669 19.497 8.48753V8.48903Z"
            fill="#969EAE"
          />
        </svg>
      </div>
    </div>
  );
};

export default CustomDatePicker;
